<div class="page">
  <app-top-bar></app-top-bar>
  <div class="main-content">
      <router-outlet></router-outlet>
  </div>
  <app-footer-bar></app-footer-bar>
</div>
